import { render, staticRenderFns } from "./title.component.vue?vue&type=template&id=140f38ae&scoped=true&"
import script from "./title.component.vue?vue&type=script&lang=ts&"
export * from "./title.component.vue?vue&type=script&lang=ts&"
import style0 from "./title.component.vue?vue&type=style&index=0&id=140f38ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140f38ae",
  null
  
)

export default component.exports